export default {
  ADD_PROFESSIONAL_PROFILE: (state, payload) => state.professional_profile = Object.assign({}, { ...payload })
}